import arrowDownSmallTokens from '@amzn/meridian-tokens/base/icon/arrow-down-small';
import arrowUpSmallTokens from '@amzn/meridian-tokens/base/icon/arrow-up-small';
import arrowRightSmallTokens from '@amzn/meridian-tokens/base/icon/arrow-right-small';
import Text from '@amzn/meridian/text';
import Icon from '@amzn/meridian/icon';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  parseFixedString,
  PERCENTAGE_TABLE,
  TIME_TABLE,
  MetricBooleanMap,
  NOTDISPLAY,
} from './helper';
import { GeneralMetricType } from './types';
import { Feature, isFeatureEnabled } from '../../../../config/FeaturesConfig';

interface DisplayScoreProp {
  metricType: string;
  metrics: GeneralMetricType;
  messageMap: any;
  displayScoreHeader: string;
  displayScoreFooter: string;
}

const DisplayScore: React.FC<DisplayScoreProp> = ({
  metricType,
  metrics,
  messageMap,
  displayScoreHeader,
  displayScoreFooter,
}: DisplayScoreProp): React.ReactElement => {
  const legacyExperience = !isFeatureEnabled(Feature.LIGHTHOUSE);

  const { change, previousDate } = metrics.topLevelMetrics;

  const isTime = TIME_TABLE[metricType as keyof MetricBooleanMap];

  if (
    previousDate === undefined ||
    messageMap === undefined ||
    legacyExperience
  ) {
    return <></>;
  }

  if (change === undefined || change === null) {
    return (
      <Text type='b200'>
        <FormattedMessage
          id='cs_perfportal_noDataToReport'
          defaultMessage='No data to report'
        />
      </Text>
    );
  }

  let parsedScore: string;
  let scoreFloat: number;
  let valueWithSign: string;
  let signCheckForTime: number;
  const hideScoreHeader = displayScoreHeader === NOTDISPLAY;
  const hideScoreFooter = displayScoreFooter === NOTDISPLAY;

  if (isTime) {
    parsedScore = change;
    signCheckForTime = parseFloat(parsedScore!.replace(':', '.'));
    valueWithSign = signCheckForTime > 0 ? `+${parsedScore}` : parsedScore;
  } else {
    if (isNaN(parseFloat(change))) {
      return <></>;
    }

    scoreFloat = parseFloat(change);

    const isPercentage = PERCENTAGE_TABLE[metricType as keyof MetricBooleanMap];

    parsedScore = parseFixedString(scoreFloat, isPercentage, false);

    valueWithSign = scoreFloat > 0 ? `+${parsedScore}` : parsedScore;
  }
  const scoreChanged = () => {
    return (
      <Text type='b200'>
        {!hideScoreHeader && (
          <FormattedMessage
            id={messageMap.headerChange.id}
            defaultMessage={messageMap.headerChange.defaultMessage}
          />
        )}
        {(scoreFloat > 0 || signCheckForTime > 0) && (
          <Icon tokens={arrowUpSmallTokens} />
        )}
        {(scoreFloat < 0 || signCheckForTime < 0) && (
          <Icon tokens={arrowDownSmallTokens} />
        )}
        {(scoreFloat === 0 || signCheckForTime === 0) && ' '}
        <b>{valueWithSign + ' '}</b>
        {!hideScoreFooter && (
          <>
            <FormattedMessage
              id={messageMap.footer.id}
              defaultMessage={messageMap.footer.defaultMessage}
            />{' '}
            {previousDate}
          </>
        )}
      </Text>
    );
  };
  const scoreSame = () => {
    // if( hideScoreHeader && hideScoreFooter)
    return hideScoreHeader && hideScoreFooter ? (
      <Icon tokens={arrowRightSmallTokens} />
    ) : (
      <Text type='b200'>
        <FormattedMessage
          id={messageMap.headerSame.id}
          defaultMessage={messageMap.headerSame.defaultMessage}
        />{' '}
        <FormattedMessage
          id={messageMap.footer.id}
          defaultMessage={messageMap.footer.defaultMessage}
        />{' '}
        {previousDate}
      </Text>
    );
  };
  return valueWithSign === '0' ||
    valueWithSign === '0%' ||
    valueWithSign === '+0%'
    ? scoreSame()
    : scoreChanged();
};

export default DisplayScore;
